module.exports = __webpack_public_path__ + "img/12.363d1f34.jpg";